import React from "react";
import { useNavigate } from "react-router-dom";
import { Image } from 'react-bootstrap';

export default function ListPartner({data, tabs, loading}) {
   const navigate = useNavigate();

   return (
      <div>
         {loading ? 
            <div>
               <div className="skeleton skeleton-list mb-3"></div>
            </div>:
            <div className="d-flex align-items-center justify-content-between py-3 border-bottom" onClick={() => navigate(`/partner/${data?.id}`)}>
               <div className="d-flex align-items-center">
                  <div className="item-transaction-icon me-4">
                     <Image src={data?.avatar} width="50px" height="50px" className="br-avatar"/>
                  </div>
                  <div className="item-transaction-activities ts-md">
                     <h6 className="text-body fw-semibold mb-0">{data?.name}</h6>
                     <div className={tabs === 'history' ? '' : 'd-none'}>
                        {data?.verification === 'success' ?
                           <div className="text-success fw-semibold ts-sm">Terverifikasi</div>:
                           <div className="text-warning fw-semibold ts-sm">Belum Terverifikasi</div>
                        }
                     </div>
                     <div className={tabs === 'verified' ? '' : 'd-none'}>
                        {data?.verification === 'success'?
                           <div className="text-success fw-semibold ts-sm">Terverifikasi</div>:
                           <div className="text-warning fw-semibold ts-sm">Proses Terverifikasi</div>
                        }
                     </div>
                     <div className={tabs === 'registered' ? '' : 'd-none'}>
                        {data?.pivot?.verification_status === 'success'?
                           <div className="text-success fw-semibold ts-sm">Terverifikasi</div>:
                           <div className="text-warning fw-semibold ts-sm">Proses Verifikasi</div>
                        }
                     </div>
                  </div>
               </div>
               <div className="d-flex align-items-center">
                  <i className="ph-caret-right ms-3 fw-bold text-dark"></i>
               </div>
            </div>
         }
      </div>
   );
}